// import {
//   Modal, ModalContent, ModalHeader, ModalBody, ModalFooter,
//   Button, useDisclosure, Input, Chip
// } from "@nextui-org/react";
// import { IconMail } from "@tabler/icons-react";
// import { Fragment, useState } from "react";
// import inspectionQueries from "../../queries/inspectionQueries";
// import { useForm } from "react-hook-form";
// import LoaderSmall from "../../components/LoaderSmall";

// const ReportModal = ({ vessel, id }) => {
//   const { isOpen, onOpen, onOpenChange } = useDisclosure();

//   const [isLoading, setIsLoading] = useState(false);
//   const [isSuccess, setIsSuccess] = useState(false);
//   const [emails, setEmails] = useState([]);
//   const [inputValue, setInputValue] = useState("");

//   const inspectionExport = inspectionQueries.useInspectionFullReport(async (res) => {
//     if (res?.success) {
//       setIsSuccess(true);
//       setIsLoading(false);
//     }
//   });

//   const { handleSubmit } = useForm();

//   const handleClose = () => {
//     onOpenChange(false);
//     setIsSuccess(false);
//     setIsLoading(false);
//     setEmails([]);
//     setInputValue("");
//   };

//   const validateEmail = (email) =>
//     /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && inputValue.trim()) {
//       e.preventDefault();
//       const email = inputValue.trim();
//       if (validateEmail(email) && !emails.includes(email)) {
//         setEmails([...emails, email]);
//         setInputValue("");
//       }
//     }
//   };

//   const removeEmail = (emailToRemove) => {
//     setEmails(emails.filter((e) => e !== emailToRemove));
//   };

//   const onSubmit = () => {
//     if (emails.length === 0) return;

//     const newData = {
//       email: emails,
//       vessel: vessel,
//       id: id,
//     };
//     setIsLoading(true);
//     inspectionExport.mutateAsync(newData);
//   };

//   return (
//     <Fragment>
//       <Button
//         onPress={onOpen}
//         className="text-[12px] flex items-center gap-2 shadow-md px-4 py-[7px] rounded-xl text-white bg-primaryGradient"
//       >
//         <IconMail size="16" className="text-white" />
//         Full Report
//       </Button>

//       <Modal
//         size="2xl"
//         isOpen={isOpen}
//         onOpenChange={onOpenChange}
//         onClose={handleClose}
//         placement="top-center"
//       >
//         <ModalContent>
//           {(onClose) =>
//             isLoading ? (
//               <div className="flex justify-center items-center min-h-[10vh]">
//                 <LoaderSmall />
//               </div>
//             ) : isSuccess ? (
//               <div className="text-[14px] font-semibold text-center justify-center items-center gap-4 mt-3 p-6">
//                 <div>Your report is being generated. Please check your inbox shortly.</div>
//               </div>
//             ) : (
//               <form onSubmit={handleSubmit(onSubmit)}>
//                 <ModalHeader className="flex flex-col gap-1">Send report to email</ModalHeader>
//                 <ModalBody>
//                   <div className="text-[13px] font-medium italic text-red-400">
//                     You can add multiple emails. Press Enter after each.
//                   </div>

//                   <div className="flex flex-wrap gap-2 my-2">
//                     {emails.map((email, idx) => (
//                       <Chip key={idx} onClose={() => removeEmail(email)}>
//                         {email}
//                       </Chip>
//                     ))}
//                   </div>

//                   <Input
//                     value={inputValue}
//                     onChange={(e) => setInputValue(e.target.value)}
//                     onKeyDown={handleKeyDown}
//                     type="email"
//                     autoFocus
//                     endContent={
//                       <IconMail
//                         size={18}
//                         className="text-default-400 pointer-events-none flex-shrink-0"
//                       />
//                     }
//                     placeholder="Enter your email and press Enter"
//                     classNames={{ input: "outline-none" }}
//                   />
//                 </ModalBody>
//                 <ModalFooter>
//                   <Button type="button" color="danger" variant="flat" onPress={handleClose}>
//                     Close
//                   </Button>
//                   <Button
//                     type="submit"
//                     color="white"
//                     className="bg-primaryGradient text-white"
//                     isDisabled={emails.length === 0}
//                   >
//                     Generate Report
//                   </Button>
//                 </ModalFooter>
//               </form>
//             )
//           }
//         </ModalContent>
//       </Modal>
//     </Fragment>
//   );
// };

// export default ReportModal;


import {
  Modal, ModalContent, ModalHeader, ModalBody, ModalFooter,
  Button, useDisclosure, Input, Chip, Card, CardBody, Avatar
} from "@nextui-org/react";
import { IconMail, IconSparkles, IconCheck, IconX, IconSend, IconFileText, IconDownload } from "@tabler/icons-react";
import { Fragment, useState } from "react";
import inspectionQueries from "../../queries/inspectionQueries";
import { useForm } from "react-hook-form";
import LoaderSmall from "../../components/LoaderSmall";
import SparkleButton from "../../components/SparkleButton";

const ReportModal = ({ vessel, id }) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [emails, setEmails] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const inspectionExport = inspectionQueries.useInspectionFullReport(async (res) => {
    if (res?.success) {
      setIsSuccess(true);
      setIsLoading(false);
    }
  });

  const { handleSubmit } = useForm();

  const handleClose = () => {
    onOpenChange(false);
    setIsSuccess(false);
    setIsLoading(false);
    setEmails([]);
    setInputValue("");
  };

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      const email = inputValue.trim();
      if (validateEmail(email) && !emails.includes(email)) {
        setEmails([...emails, email]);
        setInputValue("");
      }
    }
  };

  const removeEmail = (emailToRemove) => {
    setEmails(emails.filter((e) => e !== emailToRemove));
  };

  const onSubmit = () => {
    if (emails.length === 0) return;

    const newData = {
      email: emails,
      vessel: vessel,
      id: id,
    };
    setIsLoading(true);
    inspectionExport.mutateAsync(newData);
  };

  return (
    <Fragment>

        <SparkleButton
        Icon={IconFileText}
        btnName="Full Report"
        handleClick={onOpen}
        />

        <Modal
        size="3xl"
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        onClose={handleClose}
        placement="center"
        backdrop="blur"
        classNames={{
        backdrop: "bg-gradient-to-tr from-zinc-900/50 to-zinc-900/50 backdrop-blur-md",
        base: "border-none bg-transparent",
        wrapper: "z-[999999]"
        }}
        >
            <ModalContent className="bg-transparent shadow-none">
            {(onClose) => (
                <Card className="relative overflow-hidden border-0 shadow-2xl bg-white/95 backdrop-blur-xl">

                    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-purple-500 via-pink-500 to-indigo-500" />
                    
                    <div className="absolute inset-0 opacity-5">
                        <div className="absolute inset-0" style={{
                        backgroundImage: `radial-gradient(circle at 25% 25%, #667eea 0%, transparent 50%), 
                                        radial-gradient(circle at 75% 75%, #764ba2 0%, transparent 50%)`
                        }} />
                    </div>

                    {isLoading ? (
                        <div className="relative flex flex-col justify-center items-center min-h-[300px] p-8">
                        <div className="mb-6">
                            <div className="relative">
                            <div className="w-16 h-16 border-4 border-purple-200 border-t-purple-600 rounded-full animate-spin" />
                            <div className="absolute inset-0 w-16 h-16 border-4 border-transparent border-t-pink-500 rounded-full animate-spin animate-reverse" style={{ animationDelay: '0.3s' }} />
                            </div>
                        </div>
                        <div className="text-center space-y-2">
                            <h3 className="text-lg font-semibold text-gray-800">Generating Your Report</h3>
                            <p className="text-sm text-gray-600">Please wait while we prepare your premium report...</p>
                        </div>
                        </div>
                    ) : isSuccess ? (
                        <div className="relative text-center p-12">
                            <div className="mb-6 flex justify-center">
                                <div className="relative">
                                <div className="w-20 h-20 bg-gradient-to-br from-green-400 to-emerald-600 rounded-full flex items-center justify-center shadow-lg animate-bounce">
                                    <IconCheck size="32" className="text-white" />
                                </div>
                                <div className="absolute -inset-4 bg-gradient-to-br from-green-400/20 to-emerald-600/20 rounded-full animate-ping" />
                                </div>
                            </div>
                            <div className="space-y-4">
                                <h3 className="text-2xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
                                    Report Sent Successfully!
                                </h3>
                                <p className="text-gray-600 max-w-md mx-auto leading-relaxed">
                                    Your inspection report is being generated and will be delivered to your inbox shortly. 
                                    You'll receive a notification once it's ready.
                                </p>
                                <div className="pt-4">
                                <Button
                                onPress={handleClose}
                                className="bg-gradient-to-r from-gray-800 to-gray-700 text-white font-medium px-8 py-3 rounded-xl hover:scale-105 transition-all duration-200"
                                >
                                    Perfect, Thanks!
                                </Button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit(onSubmit)} className="relative">
                        <ModalHeader className="pb-2 pt-8 px-8">
                            <div className="flex items-center gap-4 w-full">
                                <div className="p-3 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-2xl shadow-lg">
                                    <IconMail size="24" className="text-white" />
                                </div>
                                <div className="flex-1">
                                    <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
                                    Send report to email
                                    </h2>
                                    <p className="text-sm text-gray-500 font-normal">
                                    You can add multiple emails. Press Enter after each.
                                    </p>
                                </div>
                            </div>
                        </ModalHeader>

                        <ModalBody className="px-8 py-6">
                            
                            <Card className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-100 shadow-sm">
                                <CardBody className="p-4">
                                    <div className="flex items-center gap-3">
                                        <div className="p-2 bg-blue-100 rounded-lg flex-shrink-0">
                                            <IconSparkles size="16" className="text-blue-600" />
                                        </div>
                                        <div className="text-sm">
                                            <p className="font-medium text-blue-900 mb-1">Multiple Recipients Supported</p>
                                            <p className="text-blue-700">Add multiple email addresses and press Enter after each one.</p>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>

                            {emails.length > 0 && (
                                <div className="space-y-3">
                                    <div className="flex items-center gap-2">
                                    <span className="text-sm font-medium text-gray-700">Recipients ({emails.length})</span>
                                    <div className="h-px bg-gradient-to-r from-gray-300 to-transparent flex-1" />
                                    </div>
                                    <div className="flex flex-wrap gap-2 p-4 bg-gray-50 rounded-xl border border-gray-100">
                                    {emails.map((email, idx) => (
                                        <Chip
                                        key={idx}
                                        onClose={() => removeEmail(email)}
                                        className="bg-gradient-to-r from-purple-100 to-indigo-100 text-gray-800 border border-purple-200 font-medium"
                                        closeButton={
                                            <button className="ml-2 p-0.5 hover:bg-red-100 rounded-full transition-colors">
                                            <IconX size="12" className="text-red-500" />
                                            </button>
                                        }
                                        >
                                        <div className="flex items-center gap-2">
                                            <Avatar
                                            size="sm"
                                            className="w-5 h-5"
                                            name={email.charAt(0).toUpperCase()}
                                            classNames={{
                                                base: "bg-gradient-to-br from-purple-500 to-indigo-600",
                                                name: "text-white text-xs font-semibold"
                                            }}
                                            />
                                            <span className="text-sm">{email}</span>
                                        </div>
                                        </Chip>
                                    ))}
                                    </div>
                                </div>
                            )}

                            {/* Premium Email Input */}
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Email Address</label>
                                <Input
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                                onKeyDown={handleKeyDown}
                                type="email"
                                autoFocus
                                size="lg"
                                placeholder="Enter email address and press Enter"
                                classNames={{
                                base: "group",
                                input: "text-gray-800 placeholder:text-gray-400 bg-transparent",
                                inputWrapper: "bg-white border-2 border-gray-200 hover:border-purple-300 focus-within:border-purple-500 transition-all duration-200 shadow-sm hover:shadow-md group-focus-within:shadow-lg"
                                }}
                                startContent={
                                <div className="p-2 bg-gradient-to-br from-gray-100 to-gray-200 rounded-lg">
                                    <IconMail size="18" className="text-gray-600" />
                                </div>
                                }
                                endContent={
                                inputValue && validateEmail(inputValue.trim()) && (
                                    <div className="p-1 bg-green-100 rounded-lg">
                                    <IconCheck size="16" className="text-green-600" />
                                    </div>
                                )
                                }
                                />
                            </div>
                        </ModalBody>

                        <ModalFooter className="px-8 py-6 pt-4 border-t border-gray-100 bg-gray-50/50">
                            <div className="flex items-center justify-between w-full">
                            <Button
                                type="button"
                                variant="flat"
                                onPress={handleClose}
                                className="bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium px-6 py-3 rounded-xl transition-all duration-200"
                            >
                                Cancel
                            </Button>
                            
                            <Button
                                type="submit"
                                isDisabled={emails.length === 0}
                                className="relative overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-medium px-8 py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed group"
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-500" />
                                <div className="relative flex items-center gap-2">
                                <IconSend size="18" />
                                <span>Generate & Send Report</span>
                                <div className="w-2 h-2 bg-white/30 rounded-full animate-pulse" />
                                </div>
                            </Button>
                            </div>
                        </ModalFooter>
                        </form>
                    )}

                </Card>
            )}
            </ModalContent>
        </Modal>
    </Fragment>
  );
};

export default ReportModal;